import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var KpiChartFooter = function KpiChartFooter(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
KpiChartFooter.propTypes = {
  children: node,
  className: string
};
/**
 * Default props
 */

KpiChartFooter.defaultProps = {
  children: null,
  className: ''
};
export default styled(KpiChartFooter).withConfig({
  displayName: "Footer",
  componentId: "sc-1p8m1ck-0"
})(["position:absolute;bottom:1.5rem;left:1rem;button{color:", ";}"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.primary["default"];
});